@if(loading$ | async) {

<div class="spinner-container">
  @if(customLoadingIndicator) {

  <ng-container *ngTemplateOutlet="customLoadingIndicator" />

  } @else {

  <fa-icon class="fa-solid fa-duotone fa-2xl" [icon]="['fad', 'spinner-scale']" [spin]="true"></fa-icon>
  }
</div>

}
